import Vue from "vue";
import Router from "vue-router";
import Scenarios from "./views/Scenarios";
import Login from "./Login";
import { Role } from "./utils/user.helper";
import User from "./views/User";
import UserService from "./services/user.service";
import ScenarioUpload from "./views/ScenarioUpload";
import MyScenarios from "./views/MyScenarios";
import ScenarioEdit from "./views/ScenarioEdit";
import MediaEdit from "./views/MediaEdit";
import ScenarioView from "./views/ScenarioView";
import MediaView from "./views/MediaView";
import MyProfile from "./views/MyProfile";
import Register from "./views/Register";
import RegisterPrefilled from "./views/RegisterPrefilled";
import MyPasswordChange from "./views/MyPasswordChange";
import MyPasswordChangeUpdate from "./views/MyPasswordChangeUpdate";
import MyPasswordChangeFirstLogin from "./views/MyPasswordChangeFirstLogin";
import MyDetailsChange from "./views/MyDetailsChange";
import MySupport from "./views/MySupport";
import MediaItems from "./views/MediaItems";
import MediaUpload from "./views/MediaUpload";
import MyMediaItems from "./views/MyMediaItems";
import MyLicenseClaim from "./views/MyLicenseClaim";
import MyPreReleases from "./views/MyPreReleases";
import MyDownloads from "./views/MyDownloads";
import Terms from "./views/Terms";
import Privacy from "./views/Privacy";
import EmailVerify from "./views/EmailVerify";
import UnverifiedProfile from "./views/UnverifiedProfile";
import CreateForumGroup from "./views/CreateForumGroup";
import EditForumGroup from "./views/EditForumGroup";
import ForumGroup from "./views/ForumGroup";
import MyGroups from "./views/MyGroups";
import UsersAdmin from "./views/Admin/UsersAdmin";
import ReportedForumPosts from "./views/Admin/ReportedForumPosts";
import ActivityFeed from "./views/ActivityFeed";
import Analytics from "./views/Admin/Analytics";
import AdminForumPost from "./views/Admin/AdminForumPost";
import AdminPendingMedia from "@/views/Admin/AdminPendingMedia";
import Search from "./views/Search";
import NotFound from "./views/NotFound";
import Vue2Crumbs from "vue-2-crumbs";
import { store } from "./store/store";
import Tms from "./views/Tms";
import TmsScenarios from "@/views/Tms/TmsScenarios";
import TmsStudents from "@/views/Tms/TmsStudents";
import MyProvisioning from "@/views/MyProvisioning.vue";
import MyLicenseV2Claim from "@/views/MyLicenseV2Claim.vue";
import logger from "@/utils/logger";
import Maintenance from "./views/Maintenance";
import { MAINTENANCE_MODE } from "./constants/maintenance";

Vue.use(Router);
Vue.use(Vue2Crumbs);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/logout",
      name: "logout",
      beforeEnter: (to, from, next) => {
        UserService.logout();
        return next({ path: "/login" });
      },
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/registerinvite/:token",
      name: "registerinvite",
      component: RegisterPrefilled,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/emailverified/:token",
      name: "emailverified",
      component: EmailVerify,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/unverifiedprofile/:email",
      name: "unverifiedprofile",
      component: UnverifiedProfile,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/",
      redirect: "feed",
    },
    {
      path: "/scenarios",
      name: "scenarios",
      meta: {
        breadcrumb: {
          label: "Scenarios",
        },
        navigationAvailable: true,
      },
      component: Scenarios,
    },
    {
      path: "/feed",
      name: "activity-feed",
      meta: {
        breadcrumb: {
          label: "Activity Feed",
        },
        navigationAvailable: true,
      },
      component: ActivityFeed,
      props: true,
    },
    {
      path: "/media",
      name: "media",
      meta: {
        breadcrumb: {
          label: "Media",
        },
        navigationAvailable: true,
      },
      component: MediaItems,
    },
    {
      path: "/scenario/:uuidId",
      name: "scenario-view",
      component: ScenarioView,
      meta: {
        breadcrumb: {
          label: "View Scenario",
          parent: "scenarios",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/media/upload",
      name: "media-upload",
      component: MediaUpload,
      meta: {
        breadcrumb: {
          label: "Media Upload",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/media/:uuidId",
      name: "media-view",
      component: MediaView,
      meta: {
        breadcrumb: {
          label: "View Media",
          parent: "media",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me",
      name: "my-profile",
      meta: {
        breadcrumb: {
          label: "My Profile",
        },
        navigationAvailable: true,
      },
      component: MyProfile,
    },
    {
      path: "/me/profile",
      name: "my-profile-details",
      component: MyDetailsChange,
      meta: {
        breadcrumb: {
          label: "Update Details",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/password",
      name: "my-password",
      component: MyPasswordChange,
      meta: {
        breadcrumb: {
          label: "Change Password",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/password/firstlogin",
      name: "my-password-firstlogin",
      component: MyPasswordChangeFirstLogin,
      meta: {
        breadcrumb: {
          label: "Change Password",
          parent: "my-profile"
        },
        navigationAvailable: false
      }
    },
    {
      path: "/password-update",
      name: "password-update",
      component: MyPasswordChangeUpdate,
      navigationAvailable: false,
    },
    {
      path: "/me/scenarios/:directoryUuid?",
      name: "my-scenarios",
      meta: {
        breadcrumb: {
          label: "My Scenarios",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
      component: MyScenarios,
    },
    {
      path: "/scenario/:uuidId/edit",
      name: "scenario-edit",
      component: ScenarioEdit,
      meta: {
        breadcrumb: {
          label: "Edit Scenario",
          parent: "my-scenarios",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/media",
      name: "my-media",
      meta: {
        breadcrumb: {
          label: "My Media",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
      component: MyMediaItems,
    },
    {
      path: "/media/:uuidId/edit",
      name: "media-edit",
      component: MediaEdit,
      meta: {
        breadcrumb: {
          label: "Edit Media",
          parent: "my-media",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/scenarios/upload",
      name: "scenarios-upload",
      component: ScenarioUpload,
      meta: {
        breadcrumb: {
          label: "Scenario Upload",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/forum/create",
      name: "create-forum-group",
      component: CreateForumGroup,
      meta: {
        breadcrumb: {
          label: "Create Group",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/forum/edit/:groupId",
      name: "edit-forum-group",
      component: EditForumGroup,
      meta: {
        breadcrumb: {
          label: "Edit Group",
          parent: "my-forum-groups",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/forum/groups",
      name: "my-forum-groups",
      component: MyGroups,
      meta: {
        breadcrumb: {
          label: "My Groups",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/forum/group/:groupId",
      name: "forum-group",
      component: ForumGroup,
      meta: {
        breadcrumb: {
          label: "Group",
          parent: "activity-feed",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/provisioning",
      name: "provisioning",
      component: MyProvisioning,
      meta: {
        breadcrumb: {
          label: "Provision Device",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/claim/:contractId",
      name: "my-claim",
      component: MyLicenseClaim,
      meta: {
        breadcrumb: {
          label: "Claim A License",
          parent: "provisioning",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/claimv2/:licenseUuid",
      name: "my-claim-licensev2",
      component: MyLicenseV2Claim,
      meta: {
        breadcrumb: {
          label: "Claim A License",
          parent: "provisioning",
        },
        navigationAvailable: true,
      },
    },

    {
      path: "/me/pre-release",
      name: "my-pre-release",
      component: MyPreReleases,
      meta: {
        breadcrumb: {
          label: "View Pre-Releases",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/downloads",
      name: "my-downloads",
      component: MyDownloads,
      meta: {
        breadcrumb: {
          label: "Available Downloads",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/me/support",
      name: "my-support",
      component: MySupport,
      meta: {
        breadcrumb: {
          label: "Support Information",
          parent: "my-profile",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: {
        navigationAvailable: false,
      },
    },
    {
      path: "/view-user/:id",
      name: "view-user",
      component: User,
      meta: {
        navigationAvailable: true,
        breadcrumb: {
          label: "View User",
        },
      },
    },
    { path: "/admin", redirect: "/admin/analytics" },
    {
      path: "/admin/analytics",
      name: "analytics",
      component: Analytics,
      meta: {
        breadcrumb: {
          label: "Analytics",
        },
        navigationAvailable: true,
        authorize: Role.Admin,
      },
    },
    {
      path: "/admin/users",
      name: "users-admin",
      component: UsersAdmin,
      meta: {
        breadcrumb: {
          label: "Users Management",
        },
        navigationAvailable: true,
        authorize: Role.Admin,
      },
    },
    {
      path: "/admin/reported",
      name: "reported",
      component: ReportedForumPosts,
      meta: {
        breadcrumb: {
          label: "Reported Forum Posts",
        },
        navigationAvailable: true,
        authorize: Role.Admin,
      },
    },
    {
      path: "/admin/post",
      name: "admin-forum-post",
      component: AdminForumPost,
      meta: {
        breadcrumb: {
          label: "Post to Everyone",
        },
        navigationAvailable: true,
        authorize: Role.Admin,
      },
    },
    {
      path: "/admin/reviewmedia",
      name: "admin-review-media",
      component: AdminPendingMedia,
      meta: {
        breadcrumb: {
          label: "Media to Review",
        },
        navigationAvailable: true,
        authorize: Role.Admin,
      },
    },
    {
      path: "/tms",
      name: "tms",
      component: Tms,
      children: [
        {
          path: "",
          component: TmsScenarios,
          meta: {
            navigationAvailable: true,
          },
        },
        {
          path: "students",
          component: TmsStudents,
          meta: {
            navigationAvailable: true,
          },
        },
      ],
      meta: {
        breadcrumb: {
          label: "TMS",
        },
        navigationAvailable: true,
      },
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      props: true,
      meta: {
        breadcrumb: {
          label: "Search",
        },
        navigationAvailable: true,
      },
    },

    {
      path: "*",
      name: "not-found",
      component: NotFound,
      meta: {
        breadcrumb: {
          label: "Not Found",
        },
        navigationAvailable: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (MAINTENANCE_MODE && to.path !== "/maintenance") {
    return next({ path: "/maintenance" });
  }
  if (!MAINTENANCE_MODE && to.path === "/maintenance") {
    return next({ path: "/" });
  }
  if (to.path === "/maintenance") {
    return next();
  }

  const publicPages = [
    "/login",
    "/register",
    "/password-update",
    "/terms",
    "/privacy",
  ];

  const authRequired =
    !publicPages.includes(to.path) &&
    !to.path.startsWith("/emailverified") &&
    !to.path.startsWith("/registerinvite");

  const loggedIn = store.getters.getAuthed == true;
  const { authorize } = to.meta;
  const userRole = store.getters.getUserRole;

  if (authRequired && !loggedIn) {
    logger.log("router.redirect.login_required", "Redirected to login (auth required)", { from: from.path, to: to.path });
    return next({
      path: "/login",
    });
  }

  // check if route is restricted by role
  if (authorize && (authorize & userRole) == 0) {
    // role not authorised so redirect to home page
    logger.log("router.redirect.unauthorized_role", "Redirected to home (role not authorized)", {
      from: from.path,
      to: to.path,
      userRole,
    });
    return next({ path: "/" });
  }

  const firstLoginIgnore = ["/logout", "/me/password/firstlogin", "unverifiedprofile"];

  const needsChangePassword = store.getters.getUser.force_password_change;
  if (!firstLoginIgnore.includes(to.path) && needsChangePassword) {
    logger.log("router.redirect.force_password_change", "Redirected to force password change", { from: from.path, to: to.path });
    return next({
      path: "/me/password/firstlogin"
    });
  }

  next();
});

export default router;
